module.exports = __webpack_public_path__ + "img/list3.72b7ec77.png";